import { Link } from 'react-router-dom';
import ArticleCard from '@/components/base/ArticleCard';
import { getFeaturedArticles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = getFeaturedArticles();

  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
              精选文章
            </h2>
            <p className="mt-2 text-sm text-foreground-500">由专业医生撰写的最受欢迎科普文章</p>
          </div>
          <Link
            to="/category/shengli-yuanli"
            className="hidden sm:flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
          {featured.map((article) => (
            <ArticleCard key={article.slug} article={article} variant="featured" />
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/shengli-yuanli"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors"
          >
            查看全部文章
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}